import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './NavBar';
import Page1 from './Page1';
import Page2 from './Page2';

function App() {
  const [formData, setFormData] = useState({
    annualFinancialGuarantee: '',
    hasCollateral: '', // yes/no
    collateralAmount: '',
    stopLossSpend: '',
    actuarialSpend: '',
    py2025Programs: [],
    msspTracks: [],
    companyName: '',
    email: '',
    Name: '',
    designation: '',
  });

  return (
    <Router>
      <NavBar />
      <Routes>
        <Route
          path="/"
          element={<Page1 formData={formData} setFormData={setFormData} />}
        />
        <Route
          path="/page2"
          element={<Page2 formData={formData} />}
        />
      </Routes>
    </Router>
      
  );
}

export default App;